  import { MRT_Localization_VI } from "material-react-table/locales/vi";
  import { Table_Colors } from "theme/colors";
  import { Page_Size_Options } from "constants/common";

  export const MaterialReactTableConfig = () => ({
    localization: MRT_Localization_VI,

    initialState: {
      columnVisibility: {
        id: false,
        "mrt-row-actions": false,
      },
    },

    enableColumnFilters: true,
    enableGlobalFilter: true,
    enableFilters: true,
    enableHiding: true,
    enableTopToolbar: true,
    enableBottomToolbar: true,
    enablePagination: true,
    enableSorting: true,
    enableRowActions: true,
    enableFullScreenToggle: true,
    enableStickyHeader: true,
    positionActionsColumn: "first",

    enableColumnActions: false,
    enableMultiSort: false,
    enableColumnDragging: false,
    enableColumnResizing: false,
    enableRowSelection: false,
    enableSelectAll: false,
    enableSubRowSelection: false,
    enableRowNumbers: false,
    enableRowDragging: false,
    enableRowVirtualization: false,
    enableExpanding: false,
    enableGrouping: false,
    enableEditing: false,
    enableStickyFooter: false,
    enableTableFooter: false,
    enableDensityToggle: false,

    muiTableContainerProps: {
      sx: {
        height: "calc(100% - 40px)",
        maxHeight: "calc(100% - 114px)",
        width: "100%",
        minWidth: "150px",
        maxWidth: "100%",
        overflow: "auto",
        overflowX: "auto",
        overflowY: "auto",
      },
    },

    muiTablePaperProps: {
      elevation: 0,
      sx: {
        height: "calc(100% - 114px)",
        maxHeight: "100%",
        minHeight: "150px",
        width: "100%",
        minWidth: "150px",
        maxWidth: "100%",
        border: "1px solid #e0e0e0",
        borderRadius: 0,
        overflow: "hidden",
        boxShadow: "none",
      },
    },

    muiTableBodyProps: {
      sx: {
        flex: 1,
        overflowY: "auto",
      },
    },

    muiTableHeadCellProps: {
      align: "center",
      sx: {
        backgroundColor: Table_Colors.tableHeader,
        border: `1px solid ${Table_Colors.border}`,
        fontWeight: 600,
        fontSize: "12px",
        color: Table_Colors.text.primary,
        verticalAlign: "middle",
        py: 1,
        minHeight: "40px",
        whiteSpace: "normal",
        wordWrap: "break-word",

        "& .MuiTableSortLabel-root": {
          color: Table_Colors.text.primary,
          "&.Mui-active": {
            color: Table_Colors.text.secondary,
          },
        },

        "& .MuiTableSortLabel-icon": {
          color: Table_Colors.text.secondary,
          fontSize: "16px",
        },

        "& .MuiIconButton-root": {
          color: Table_Colors.text.secondary,
          padding: "4px",
        },
      },
    },

    muiFilterTextFieldProps: {
      placeholder: "Nhập từ khóa...",
      size: "small",
      sx: {
        fontSize: "11px",
        minWidth: "150px",
      },
    },

    muiSearchTextFieldProps: {
      sx: {
        minWidth: "200px",
        "& .MuiOutlinedInput-root": {
          fontSize: "14px",
          height: "38px",
        },
      },
    },

    muiEditTextFieldProps: {
      size: "small",
      sx: {
        "& .MuiInputBase-root": {
          fontFamily: "Inter, sans-serif",
          fontSize: "13px",
        },
        "& .MuiInputBase-input": {
          fontFamily: "Inter, sans-serif",
          fontSize: "13px",
        },
        "& .MuiSelect-select": {
          fontFamily: "Inter, sans-serif",
          fontSize: "13px",
        },
      },
      SelectProps: {
        MenuProps: {
          PaperProps: {
            sx: {
              maxHeight: 280,
              "& .MuiMenuItem-root": {
                fontFamily: "Inter, sans-serif",
                fontSize: "13px",
              },
            },
          },
        },
      },
    },

    muiTableBodyCellProps: {
      align: "center",
      sx: {
        width: "100%",
        height: "40px",
        minHeight: "40px",
        border: `1px solid ${Table_Colors.border}`,
        fontSize: "13px",
        fontWeight: "normal",
        py: 1,
      },
    },

    muiBottomToolbarProps: {
      sx: {
        borderRadius: "0px",
        flexShrink: 0,
        backgroundColor: Table_Colors.tableHeader,
        py: 1,
        px: 2,
        "& .MuiTablePagination-root": {
          fontSize: "12px",
        },
        height: "40px",
      },
    },

    muiPaginationProps: {
      rowsPerPageOptions: Page_Size_Options,
      shape: "rounded",
      color: "primary",
      showFirstButton: false,
      showLastButton: false,
    },

    muiTableProps: {
      stickyHeader: true,
      sx: {
        border: `1px solid ${Table_Colors.border}`,
        tableLayout: "fixed",
        width: "100%",
        minWidth: "150px",
        maxWidth: "100%",
      },
    },

    muiCircularProgressProps: {
      color: "secondary",
      thickness: 4,
      size: 45,
    },

    muiSkeletonProps: {
      animation: "pulse",
      height: 28,
    },
  });
